import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { common } from '../common';

import { hideGenderIcon } from './helpers/hide-gender-icon';

export const horizontalScrollablePanelBoughtThisSeason = mergeMultipleConfigs(
  common.horizontalScrollablePanelBoughtThisSeason,
  [
    hideGenderIcon,
    {
      id: 'root',
      data: {
        aggregationType: 1,
        dateRangeField: 1,
        backgroundColor: 'rgba(232, 232, 232, 0.6)',

        headerVariables: {
          provider: 'id:root',
          property: 'activeByPreset',
          transform: function (activeByPreset: boolean) {
            if (activeByPreset) {
              return [
                {
                  key: '--btn-primary-background',
                  value: 'rgba(255, 213, 33, 1)',
                },
                {
                  key: '--btn-primary-color',
                  value: '#333',
                },
              ];
            } else {
              return [
                {
                  key: '--btn-primary-background',
                  value: '#333',
                },
                {
                  key: '--btn-primary-color',
                  value: '#fff',
                },
              ];
            }
          }.toString(),
        },
      },
    },
  ],
);
